export default {
  stepper: {
    description: 'Ravintolan käyttöönotto',
    steps: {
      confirm_email: 'Vahvista sähköpostiosoite',
      add_store_details: 'Lisää myymäläsi tiedot',
      add_personal_details: 'Lisää henkilötietosi',
      add_bank_details: 'Lisää pankkitiedot tilityksiä varten',
      add_tax_details: 'Onko yrityksesi arvonlisäverovelvollinen?',
      upload_business_doc: 'Yritystoiminnan todiste',
      upload_personal_doc: 'Henkilöllisyyden todiste',
      confirm_details: 'Vastaanota maksuja',
    },
  },
  completed: {
    title: 'Käyttöönotto valmis',
    description:
      'Käyttöönottosi on valmis. Voit lisätä asiakirjoja täällä milloin tahansa, esimerkiksi uuden osakkaan henkilötodistuksen tai uusitun henkilötodistuksen.',
  },
  toasts: {
    failed_to_skip_verification_step: 'Vahvistusvaiheen ohittaminen epäonnistui. Yritä uudelleen',
  },
};
